module.exports = __webpack_public_path__ + "img/address_sheet_margins.54ce6e18.png";